import {CONTENT_CATEGORY_PARAMETER, CONTENT_TYPE_TEXT} from '../../constants';

export default {
  id: 'NB_CLIENTS',
  title: 'Comment est calculé le nombre de clients avec qui je suis en relation ?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'En tant que déposant français hors succursale, votre offre vous permet de diffuser vos documents à un nombre de clients maximum, défini en fonction de l\'offre choisie.'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: 'Le nombre de clients actifs avec qui votre entreprise est en relation, est calculé en additionnant le Nombre de clients français au niveau entreprise (SIREN) et le Nombre de clients non français au niveau établissement, en excluant OFA et les entreprises partenaires d\'OFA (ILG, Actradis, Hiveo, Subclic)'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: 'Prenons l\'exemple d\'une entreprise déposante française hors succursale qui partage ses documents avec les clients actifs suivants :'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '1. Etablissement français 12345678900001'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '2. Etablissement français 12345678900002'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '3. Etablissement français 11111111100001'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '4. Etablissement allemand'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '5. OFA'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: 'Ce déposant est en relation avec 3 Clients : l\'entreprise 123456789, l\'entreprise 111111111 et l\'établissement allemand.'
  }]
};
